module.exports = __webpack_public_path__ + "img/infected.a2dd40a3.png";